export default class Globals {
  constructor() {
    this.initBeforeDOMReady();

    document.addEventListener('DOMContentLoaded', this.init);
  }

  initBeforeDOMReady() {
    // Register solodev namespace.
    const path =new URL(document.baseURI).pathname;
    const orgName = path.split('/')[1] === 'o' ? path.split('/')[2] : null;
    window.solodev = {
      ...window.solodev,
      config: {
        orgName,
      },
    };

    // Remove "code" param from current URL if it exists to
    // prevent post and session issues.
    // --------------------------------------------------------------------------
    const uri = window.location.toString();
    if (uri.indexOf("?code=") > 0) {
      const clean_uri = uri.substring(0, uri.indexOf("?code="));
      window.history.replaceState({}, document.title, clean_uri);
    }

    if (window.isBaseTemplate || false) {
      // Modals do not usually have the base twig. Usually means a submission
      // has happened. Reload in top frame.
      if (window.self !== window.top) {
        top.closeAction();
        top.document.location = window.self.location;
      }

      // Force reloading page if user clicks "back" button in the browser.
      // (this is solution for problem related to loading cache instead of page from server).
      window.addEventListener( "pageshow", function ( event ) {
        var historyTraversal = event.persisted ||
          ( typeof window.performance != "undefined" &&
            window.performance.navigation.type === 2 );
        if ( historyTraversal ) {
          // Handle page restore.
          window.location.reload();
        }
      });
    }
  }

  init() {
    // STOP PROPAGATION.
    // --------------------------------------------------------------------------
    // We don't want add click listener
    // to document.body element!
    const stopPropagationElem = document.querySelectorAll('[js-stop-propagation]');
    stopPropagationElem.forEach(el => {
      el.addEventListener('click', e => {
        e.stopImmediatePropagation()
      });
    });
  }
}
